import { useTranslation } from 'react-i18next';

import quizBannerMobileImg from '../../../../../common/assets/images/marketing/quiz_banner_mobile.png';
import quizBannerSmallImg from '../../../../../common/assets/images/marketing/quiz_banner_small.png';
import quizBannerWideImg from '../../../../../common/assets/images/marketing/quiz_banner_wide.png';
import { resources } from '../../../resources/resources';
import MarketingHomePageBanner from './MarketingHomePageBanner';

type MarketingBannerVariant = 'wide' | 'small';

interface QuizBannerProps {
  variant: MarketingBannerVariant;
}

export default function QuizBanner({ variant }: Readonly<QuizBannerProps>) {
  const { t: translate } = useTranslation();
  const desktopImage =
    variant === 'wide' ? quizBannerWideImg : quizBannerSmallImg;
  return (
    <MarketingHomePageBanner
      variant={variant}
      title={translate(resources.quiz.banners.title)}
      description={translate(resources.quiz.banners.description)}
      actionLabel={translate(resources.quiz.banners.action)}
      desktopImage={desktopImage}
      mobileImage={quizBannerMobileImg}
    />
  );
}
